import React, { useState, useEffect, useContext } from 'react';
import { Container, Form, Button, Card, Row, Col, Alert } from 'react-bootstrap';
import { AuthContext } from '../../contexts/AuthContext';
import api from '../../services/api';
import './Profile.css';

const Profile = () => {
  const { user } = useContext(AuthContext);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  // 密碼變更狀態
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  
  useEffect(() => {
    if (user) {
      loadProfile();
    }
  }, [user]);
  
  const loadProfile = async () => {
    setLoading(true);
    try {
      const response = await api.get('/auth/profile');
      setProfile(response.data.user);
      setError('');
    } catch (err) {
      console.error('載入用戶資料失敗:', err);
      setError('載入用戶資料失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  };
  
  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setUpdating(true);
    setError('');
    setSuccess('');
    
    try {
      // 在這裡，您可以實現更新用戶資料的功能
      // 例如：修改電話號碼等
      await api.put('/users/profile', {
        phone: profile.phone
      });
      
      setSuccess('用戶資料已成功更新');
    } catch (err) {
      console.error('更新用戶資料失敗:', err);
      setError('更新用戶資料失敗: ' + (err.response?.data?.message || '請稍後再試'));
    } finally {
      setUpdating(false);
    }
  };
  
  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPasswordError('');
    setPasswordSuccess('');
    
    // 驗證新密碼
    if (newPassword !== confirmPassword) {
      setPasswordError('新密碼和確認密碼不匹配');
      return;
    }
    
    if (newPassword.length < 6) {
      setPasswordError('新密碼至少需要6個字符');
      return;
    }
    
    setUpdating(true);
    
    try {
      await api.put('/auth/password', {
        current_password: currentPassword,
        new_password: newPassword
      });
      
      // 清除輸入
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      
      setPasswordSuccess('密碼已成功更新');
    } catch (err) {
      console.error('更新密碼失敗:', err);
      setPasswordError('更新密碼失敗: ' + (err.response?.data?.message || '請確認當前密碼是否正確'));
    } finally {
      setUpdating(false);
    }
  };
  
  return (
    <Container className="profile-container">
      <h2 className="mb-4">個人資料</h2>
      
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}
      
      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">載入中...</span>
          </div>
        </div>
      ) : profile ? (
        <Row>
          <Col md={6}>
            <Card className="mb-4">
              <Card.Header>基本資料</Card.Header>
              <Card.Body>
                <Form onSubmit={handleUpdateProfile}>
                  <Form.Group className="mb-3">
                    <Form.Label>登入ID</Form.Label>
                    <Form.Control 
                      type="text" 
                      value={profile.login_id || ''} 
                      disabled
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>角色</Form.Label>
                    <Form.Control 
                      type="text" 
                      value={profile.role === 0 ? '管理員' : '客戶'} 
                      disabled
                    />
                  </Form.Group>
                  
                  {/* <Form.Group className="mb-3">
                    <Form.Label>電話號碼</Form.Label>
                    <Form.Control 
                      type="text" 
                      value={profile.phone || ''} 
                      onChange={(e) => setProfile({...profile, phone: e.target.value})}
                      disabled
                    />
                  </Form.Group> */}
                  
                  {/* <Button 
                    variant="primary" 
                    type="submit" 
                    disabled={updating}
                  >
                    {updating ? '更新中...' : '更新資料'}
                  </Button> */}
                </Form>
              </Card.Body>
            </Card>
          </Col>
          
          <Col md={6}>
            <Card>
              <Card.Header>變更密碼</Card.Header>
              <Card.Body>
                {passwordError && <Alert variant="danger">{passwordError}</Alert>}
                {passwordSuccess && <Alert variant="success">{passwordSuccess}</Alert>}
                
                <Form onSubmit={handleChangePassword}>
                  <Form.Group className="mb-3">
                    <Form.Label>當前密碼</Form.Label>
                    <Form.Control 
                      type="password" 
                      value={currentPassword} 
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>新密碼</Form.Label>
                    <Form.Control 
                      type="password" 
                      value={newPassword} 
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>確認新密碼</Form.Label>
                    <Form.Control 
                      type="password" 
                      value={confirmPassword} 
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                  
                  <Button 
                    variant="primary" 
                    type="submit" 
                    disabled={updating}
                  >
                    {updating ? '更新中...' : '變更密碼'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <div className="text-center my-5">
          <p>無法載入用戶資料</p>
        </div>
      )}
    </Container>
  );
};

export default Profile;